import { Component, ElementRef, HostListener, ViewChild, AfterViewInit } from '@angular/core';
import { ShareddtaService } from '@app/services/shareddta.service';
import { Router } from '@angular/router';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { AuthServiceService } from '@app/services/auth-service.service';
import { ToastService } from '@app/services/toast.service';
interface Slides {
  image: string;
  title: string;
  description: string;
}
@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements AfterViewInit {
  @ViewChild('sliderWrapper') sliderWrapper!: ElementRef;

  loginForm!: FormGroup;
  submitted = false;
  showPassword = false;
  rememberedEmails: string[] = []; // Add this

  // Slider properties
  slides: Slides[] = [
    {
      image: '../../../../assets/images/banner_1.png',
      title: 'Track Every Delivery',
      description: 'Real-time GPS tracking for complete visibility'
    },
    {
      image: '../../../../assets/images/banner_2.png',
      title: 'Optimize Routes',
      description: 'AI-powered routing for faster deliveries'
    },
    {
      image: '../../../../assets/images/banner_3.png',
      title: 'Smart Analytics',
      description: 'Make data-driven decisions with insights'
    },
    {
      image: '../../../../assets/images/banner_4.png',
      title: 'Happy Customers',
      description: 'Deliver exceptional service every time'
    },
    {
      image: '../../../../assets/images/banner_5.png',
      title: 'Seamless Management',
      description: 'Centralized control for your entire fleet'
    }
  ];
  currentSlide = 0;
  slideInterval: any;
  isTransitioning = false;

  // Touch/Swipe
  touchStartX = 0;
  touchEndX = 0;
  progress = 0;
  // Mouse drag
  isDragging = false;
  dragStartX = 0;

  constructor(private fb: FormBuilder, private router: Router, public authService: AuthServiceService,
    private toastr: ToastrService, private toast: ToastService, private sharedData: ShareddtaService) { }

  ngAfterViewInit(): void {
    this.sharedData.signalPageReady();
  }

  ngOnInit(): void {
    const savedEmails = JSON.parse(localStorage.getItem('remembered_emails') || '[]');
    this.rememberedEmails = savedEmails;
    const lastEmail = savedEmails.length > 0 ? savedEmails[0] : '';

    // Initialize login form
    this.loginForm = this.fb.group({
      email: [lastEmail, [Validators.required, Validators.pattern(
        /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/
      )]],
    });

    // Start slider
    this.showSlide(0);
    this.startSlider();
    localStorage.setItem('isLoggedIn', 'false')
  }

  togglePassword() {
    this.showPassword = !this.showPassword;
  }

  // Modal properties
  showSelectionModal = false;
  selectedOption = '';
  showSelectionError = false;

  organizations = 'Admin'
  loginData: any;
  multiplecompany: boolean = false;
  isSubmitting = false;
  onSubmit(): void {
    this.submitted = true;
    if (this.loginForm.invalid) {
      this.toast.show('error', 'Please enter a valid email address');
      document.getElementById('email')?.focus();
      return;
    }
    this.isSubmitting = true;
    const email = this.loginForm.get('email')?.value;

    // Save the email to history in localStorage
    let emails = JSON.parse(localStorage.getItem('remembered_emails') || '[]');
    emails = [email, ...emails.filter((e: string) => e !== email)].slice(0, 5);
    localStorage.setItem('remembered_emails', JSON.stringify(emails));
    this.rememberedEmails = emails;

    // Save the email to localStorage on successful login
    if (email === 'realtimetrac.owner@gmail.com') {
      // 👉 External URL redirect
      window.location.href = 'https://production.realtimetrac.com/';
      return;
    }
    sessionStorage.setItem('savedEmail', email);



    this.authService.getOrganization(this.loginForm.get('email')?.value, this.organizations).subscribe(
      (data: any) => {
        this.isSubmitting = false;
        if (this.authService.resultCodeError(data)) {
          return;
        }
        this.loginData = data?.result
        this.authService.setLS('OtpLogin', 'false');
        //window.location.reload();
        if (data.result.length == 1) {
          this.authService.setLS('org_email', data?.result[0]?.email);
          this.authService.setLS('org_name', data?.result[0]?.organization.name);
          this.authService.setLS('org_Id', data?.result[0]?.organization.id);
          this.authService.setLS('schema_name', data?.result[0]?.organization.schema_name);
          this.authService.setLS('compname', data?.result[0]?.organization.name);
          this.authService.setLS('adminPhoneNumber', data?.result[0]?.phone_number);
          this.authService.setLS('countryCode', data?.result[0]?.organization.country_code);
          this.authService.setLS('logo', data?.result[0]?.organization.logo);
          this.authService.setLS(
            'subscription_status',
            data?.result[0]?.organization?.subscription_status?.toLowerCase() || ''
          );
          this.authService.setLS(
            'org_domain',
            data?.result[0]?.organization?.domain_url
          );
          this.authService._apiUrl.next(
            data?.result[0]?.organization?.domain_url +
            ':' +
            this.authService.port
          );
          this.authService.setLS('org_phone', data?.result[0]?.phone_number);
          // this.authService.setLS('org_data', JSON.stringify(data));

          this.toast.show('success', data.resultDescription);

          this.router.navigate(['/login']);
        }
        if (data.result.length > 1) {
          // this.multiplecompany =true
          this.openSelectionModal();
        }
        // window.location.reload();
      },
      (error) => {
        this.isSubmitting = false;
        this.authService.dataError(error);
      }
    );
    // console.log('Email:', this.loginForm.value.email);
    // this.router.navigate(['/login']);
  }

  // ---------------- Slider Methods ----------------

  showSlide(index: number, direction: 'next' | 'prev' = 'next') {
    if (this.isTransitioning) return;
    this.isTransitioning = true;
    this.progressInterval = setInterval(() => {
      this.progress += 2; // 100 / 50 steps = 2%

      if (this.progress >= 100) {
        this.progress = 100;
        clearInterval(this.progressInterval);
      }
    }, 100); //
    const prevIndex = this.currentSlide;
    this.currentSlide = index;

    setTimeout(() => {
      this.isTransitioning = false;
    }, 800);
  }

  nextSlide() {
    this.showSlide((this.currentSlide + 1) % this.slides.length, 'next');
    this.resetSlider();
  }

  prevSlide() {
    this.showSlide(
      (this.currentSlide - 1 + this.slides.length) % this.slides.length,
      'prev'
    );
    this.resetSlider();
  }
  progressInterval: any;
  startSlider() {
    clearInterval(this.slideInterval);
    this.slideInterval = setInterval(() => this.nextSlide(), 5000);
  }

  resetSlider() {
    clearInterval(this.slideInterval);
    this.startSlider();
  }

  // ---------------- Touch / Drag ----------------

  onTouchStart(event: TouchEvent) {
    this.touchStartX = event.changedTouches[0].screenX;
  }

  onTouchEnd(event: TouchEvent) {
    this.touchEndX = event.changedTouches[0].screenX;
    this.handleSwipe();
  }

  onMouseDown(event: MouseEvent) {
    this.isDragging = true;
    this.dragStartX = event.clientX;
  }

  onMouseMove(event: MouseEvent) {
    if (!this.isDragging) return;
    event.preventDefault();
  }

  onMouseUp(event: MouseEvent) {
    if (!this.isDragging) return;
    this.isDragging = false;

    const diff = this.dragStartX - event.clientX;
    if (Math.abs(diff) > 50) {
      if (diff > 0) this.nextSlide();
      else this.prevSlide();
      this.resetSlider();
    }
  }

  onMouseLeave() {
    this.isDragging = false;
  }

  handleSwipe() {
    const diff = this.touchStartX - this.touchEndX;
    if (Math.abs(diff) > 50) {
      if (diff > 0) this.nextSlide();
      else this.prevSlide();
      this.resetSlider();
    }
  }

  // ---------------- Keyboard ----------------
  @HostListener('document:keydown', ['$event'])
  handleKeyboard(event: KeyboardEvent) {
    if (event.key === 'ArrowLeft') this.prevSlide();
    else if (event.key === 'ArrowRight') this.nextSlide();
  }

  // ---------------- Pause on Hover ----------------
  onMouseEnter() {
    clearInterval(this.slideInterval);
  }

  onMouseLeaveWrapper() {
    this.startSlider();
  }


  onKeyDown(event: KeyboardEvent) {
    this.submitted = false;
  }

  // ========== SELECTION MODAL METHODS ==========
  openSelectionModal() {
    this.showSelectionModal = true;
    this.showSelectionError = false;
    this.selectedCompany = '';
  }

  closeSelectionModal() {
    this.showSelectionModal = false;
    this.showSelectionError = false;
    this.selectedCompany = '';
  }

  onSelectionConfirm() {
    if (!this.selectedCompany || this.selectedCompany === '') {
      this.showSelectionError = true;
      return;
    }

    // Handle the selected option here
    console.log('Selected option:', this.selectedOption);
    this.router.navigate(['/login']);

    // Close modal and proceed
    this.closeSelectionModal();
  }
  selectedCompany: string = '';
  onCompanySelect(event: any) {
    const index = event.target.value; // get index of selected option
    const selectedData = this.loginData[index]; // get full object
    this.selectedCompany = index;
    if (selectedData.organization.org_status == false) {
      this.toast.show('error', 'Your organization is currently inactive. Please contact support.');
      this.closeSelectionModal();
      return;
    }
    if (selectedData && selectedData.organization) {
      this.authService.setLS('org_email', selectedData.email);
      this.authService.setLS('org_name', selectedData.organization.name);
      this.authService.setLS('org_Id', selectedData.organization.id);
      this.authService.setLS('schema_name', selectedData.organization.schema_name);
      this.authService.setLS('compname', selectedData.organization.name);
      this.authService.setLS('adminPhoneNumber', selectedData.phone_number);
      this.authService.setLS('logo', selectedData.organization.logo);
      this.authService.setLS('org_domain', selectedData.organization.domain_url);
      this.authService.setLS('org_phone', selectedData.phone_number);

      this.authService._apiUrl.next(
        selectedData.organization.domain_url + ':' + this.authService.port
      );

      console.log('Selected organization details saved:', selectedData.organization.name);
    }
  }
}
